import React from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

const SocialShareButton = ({ description, handleClick, platform, title, url }) => {
  const { alt, class: className, icon, platform: platformName } = platform;
  const ButtonComponent =
    platformName === 'X'
      ? TwitterShareButton
      : platformName === 'Facebook'
      ? FacebookShareButton
      : platformName === 'LinkedIn'
      ? LinkedinShareButton
      : platformName === 'Email'
      ? EmailShareButton
      : null;

  if (ButtonComponent) {
    return (
      <div
        onClick={() => handleClick(platformName)}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick(platformName);
          }
        }}
        role="button"
        tabIndex="0"
      >
        <ButtonComponent
          className={`${className || ''} flex`}
          url={url}
          title={title}
          quote={title}
          summary={description}
        >
          <img src={icon} width="64" height="64" border="0" alt={alt} />
        </ButtonComponent>
      </div>
    );
  }

  return null;
};

export default SocialShareButton;
